<template>
<div>
  <v-toolbar color="white" flat id="headMenu">
    <router-link :to="{name: 'home'}">
      <img src="@/assets/img/logo.png" alt="カライイネ">
    </router-link> 
    <v-layout row wrap v-if="!isSP" style="margin-left: 16px;">
      <router-link :to="{name: 'about'}" class="headerBtn">
        カライイネとは？
      </router-link>
      <router-link :to="{name: 'searchFood'}" class="headerBtn">
        辛い食品
      </router-link>
      <router-link :to="{name: 'searchShops'}" class="headerBtn">
        辛い飲食店
      </router-link>
      <router-link :to="{name: 'searchReview'}" class="headerBtn">
        みんなのカラログ
      </router-link>
      <router-link :to="{name: 'NewsList'}" class="headerBtn">
        辛いニュース
      </router-link>
      <!-- <router-link :to="{name: 'MagazinList'}" class="headerBtn">
        マガジン
      </router-link> -->
    </v-layout>
    <v-spacer></v-spacer>
    <span v-if="!isLogin">
      <router-link :to="{name: 'login'}" style="color:#000;text-decoration:none;">
        <div style="padding:5px;font-weight:bold;font-size:120%;">ログイン</div> 
      </router-link>
    </span>
    <v-btn v-if="isLogin" icon :to="{name: 'UserInfoView'}">
      <v-badge left overlap>
      <template v-if="userInfoCount>0" v-slot:badge>{{userInfoCount}}</template>
      <v-icon large>notifications_none</v-icon>
    </v-badge>
    </v-btn>
    <v-btn icon @click="isQueryOpen=!isQueryOpen">
      <v-icon v-if="!isQueryOpen" large>search</v-icon>
      <v-icon v-else large>close</v-icon>
    </v-btn>
    <v-toolbar-side-icon  @click.stop="drawer = !drawer"></v-toolbar-side-icon>
  </v-toolbar>
  <v-navigation-drawer v-model="drawer" app cliped right class="primary" dark>
    <v-subheader @click.stop="drawer = !drawer">
      <v-flex xs12 style="text-align:right;cursor: pointer;"><v-icon large>close</v-icon></v-flex>
    </v-subheader>
    <v-layout 
      @click="$router.push({name: 'UserTop', params: {id: uid}})"
      v-if="isLogin" row wrap style="text-align:left;padding-left:16px;cursor: pointer"
    >
      <v-flex xs2><v-avatar size="45"><v-img :src="imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/></v-avatar></v-flex>
      <v-flex xs10>
        <p style="font-size:14pt;margin:0;color:#fff;font-weight:bold;">{{displayName}}</p>
        <p style="font-size:10pt;color:#ddd;margin:0">マイページへ</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!isLogin">
      <v-flex xs12 class="white">
        <v-container style="text-align:center;">
          <v-btn outline color="primary" block :to="{name: 'login'}">
            ログイン
          </v-btn>
          <!-- <v-btn dark color="primary" :to="{name: 'login', query: {signup: true}}">
            新規登録
          </v-btn> -->
        </v-container>
      </v-flex>
    </v-layout>
    <v-list>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'home'})">
        <v-list-tile-avatar><v-icon>home</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>トップページ</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'about'})">
        <v-list-tile-avatar><v-icon>help_outline</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>カライイネとは？</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'reviewPostSearchFood'})">
        <v-list-tile-avatar><v-icon>add</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>カラログを投稿する</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'searchReview'})">
        <v-list-tile-avatar><v-icon>chat_bubble_outline</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>みんなのカラログ</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'searchFood'})">
        <v-list-tile-avatar><v-icon>search</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>カライ食品検索</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'searchShops'})">
        <v-list-tile-avatar><v-icon>restaurant</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>飲食店検索</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'NewsList'})">
        <v-list-tile-avatar><v-icon>dvr</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>辛いニュース</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <!-- <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'MagazinList'})">
        <v-list-tile-avatar><v-icon>local_library</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>マガジン</v-list-tile-title></v-list-tile-content>
      </v-list-tile> -->
      <v-list-tile avatar @click="drawer = !drawer;$router.push({name: 'editFood'})">
        <v-list-tile-avatar><v-icon>add</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>カライモノ登録</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="isLogin" avatar @click="drawer = !drawer;$router.push({name: 'UserTop', params: {id: uid}})">
        <v-list-tile-avatar><v-icon>person</v-icon></v-list-tile-avatar>
        <v-list-tile-content><v-list-tile-title>マイページ</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="isLogin" @click="logout">
        <v-list-tile-content><v-list-tile-title>ログアウト</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <v-expand-transition>
    <v-card v-show="isQueryOpen" style="max-width:800px;margin:0 auto;" flat>
      <v-container>
        <v-layout row wrap>
          <v-flex xs10>
            <input type="text" id="headerSearch"
              v-model="query_kwd"
              outline
              placeholder="食品をキーワードで検索する"/>
          </v-flex>
          <v-flex xs2>
            <v-btn icon color="primary" @click="onSearch"><v-icon>search</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-expand-transition>
</div>
</template>

<script>
import { auth } from '../../main'
// @ is an alias to /src
export default {
  name: 'CommonHeader',
  data () {
    return {
      drawer: false,
      isQueryOpen: false,
      query_kwd: ''
    }
  },
  props: {
    pageName: String
  },
  computed: {
    displayName () {
      return this.$store.state.user.displayName
    },
    imageurl () {
      return this.$store.state.user.imageurl
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    uid () {
      return this.$store.state.user.uid
    },
    isTop () {
      if (this.pageName === 'home') return true
      return false
    },
    userInfoCount () {
      return this.$store.state.userInfo.userInfoCount
    },
    displaySize () {
      return this.$vuetify.breakpoint.name
    },
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    }
  },
  created () {
    // this.$store.dispatch('getCategoryAndTag')
  },
  mounted () {
  },
  methods: {
    logout () {
      auth.signOut().then(() => {
        this.$store.commit('logout')
        let obj = {
          group: 'messageBottom',
          type: 'success',
          title: 'information',
          text: 'ログアウトしました。'
        }
        this.$emit('onMessage', obj)
      })
    },
    onSearch () {
      let query = {}
      if (this.query_kwd !== '') {
        query.kwd = this.query_kwd
        query.s = '1'
      }
      this.isQueryOpen = false
      this.query_kwd = ''
      this.$router.push({name: 'searchFood', query: query})
    }
  },
  components: {
  }
}
</script>
<style scoped>
/* #headMenu::before {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 4px;
    background-image: linear-gradient(90deg,#f44336,#ff8214);
    content: "";
} */
/* #headMenu >>> .v-toolbar__content {
  padding-top:7px;
  border-bottom: 1px solid #dddzz;
} */
#headerSearch {
  border: solid 1px #aaa;
  margin-top:2  px;
  padding: 10px;
  width: 100%;
  border-radius:5px;
}
.headerBtn {
  color:#444;
  text-decoration:none;
  padding:5px 10px;
  font-weight:bold;
  font-size:13pt;
}

</style>
